module.exports = __webpack_public_path__ + "static/bottom-902b5e182fc3ff49c578fda643bebdea.png";